import { useState, useEffect } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import _ from 'lodash'

import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import DeleteIcon from '@mui/icons-material/Delete'
import LowPriorityIcon from '@mui/icons-material/LowPriority'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import AddIcon from '@mui/icons-material/Add'

import { constants } from '../../Constants/constants'
import { post } from '../../helper/baseFetch'
import { setRestaurantClone, setRestaurantCloneValue } from '../../actions/restaurantAction'
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay'
import { TempTextInput } from '../../Component/Input/TempTextInput'
import { TempCheckBox } from '../../Component/Input/TempCheckBox'
import { TempBtn } from '../../Component/Input/TempBtn'
import { TempAutoSelectInput } from '../../Component/Input/TempAutoSelectInput'
import { GlobalDialog } from '../../Component/GlobalDialog'
import { helperTextStyles } from '../../helper/util'
import { MerchantUserCreate } from '../MerchantUser/MerchantUserCreate'
import { Box, Drawer, Card } from '@mui/material'

import { SelectTagList } from '../SelectTag/SelectTagList'

import MerchantUserValidation from '../../validations/merchantUserValidation'
import { setMerchantUser } from '../../actions'

import SelectTagValidation from '../../validations/selectTagValidation'
import { setSelectTagConfigOptions } from '../../actions/selectTagConfigOptionsAction'

import { selectTagValidationConstants } from '../../Constants/validationConstants'

const restUrlIdRegex = /^[\d]{1,20}$/

export const RestaurantClone = () => {
  //----------------------Select Tag Config Create------------------------
  const savedSelectTagConfigOptions = useSelector(state => state.selectTagConfigOptions.ui.selectTagConfigOptions);
  //----------------------Merchant User Create------------------------
  const savedMerchantUser = useSelector((state) => state.merchantUser.ui.merchantUser)
  // eslint-disable-next-line no-unused-vars
  const [errorVersion, setErrorVersion] = useState(MerchantUserValidation.getVersion())
  //----------------------End Of Merchant User Create------------------------
  const params = useParams()
  const dispatch = useDispatch()
  const store = useStore()
  const history = useHistory()
  const [clear, setClear] = useState(false)

  const [dialog, setDialog] = useState({
    open: false,
    dialogActions: [],
  })
  const [restUrlIdError, setRestUrlIdError] = useState(null)
  const [selectTagMap, setSelectTagMap] = useState(new Map())
  const [showSelectTagPanel, setShowSelectTagPanel] = useState(false)
  const savedRestaurantClone = useSelector((state) => state.restaurant.ui.restaurantClone)
  const helperTextStylesClasses = helperTextStyles()
  const resource = 'restaurant'
  const tabs = [
    {
      label: { resource: resource, key: 'info' },
      tabIndex: constants.AREA_EDIT_TAB.INFO,
    },
  ]

  const tempEditList = [
    {
      className: 'edit-create-input',
      variant: constants.STYLE.VARIANT.STANDARD,
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'restUrlId' },
      value: savedRestaurantClone.restUrlIdSource,
      name: 'restUrlIdSource',
      isEndOfLine: true,
      disabled: true,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'newRestUrlID' },
      value: savedRestaurantClone.restUrlIdTarget,
      name: 'restUrlIdTarget',
      isEndOfLine: true,
      required: true,
      helperTextIcon: true,
      helperText: restUrlIdError,
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
    {
      className: 'edit-create-input edit-display-wrapper',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'queue' },
      value: savedRestaurantClone.queue,
      name: 'queue',
      type: constants.TYPE.CHECKBOX,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input edit-display-wrapper',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'reservation' },
      value: savedRestaurantClone.reservation,
      name: 'reservation',
      type: constants.TYPE.CHECKBOX,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input edit-display-wrapper',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'slideshow' },
      value: savedRestaurantClone.slideshow,
      name: 'slideshow',
      type: constants.TYPE.CHECKBOX,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input edit-display-wrapper',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'banner' },
      value: savedRestaurantClone.banner,
      name: 'banner',
      type: constants.TYPE.CHECKBOX,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input edit-display-wrapper',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'systemGroup' },
      value: savedRestaurantClone.systemGroup,
      name: 'systemGroup',
      type: constants.TYPE.CHECKBOX,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input edit-display-wrapper',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'systemGroupGorilla' },
      value: savedRestaurantClone.systemGroupGorilla,
      name: 'systemGroupGorilla',
      type: constants.TYPE.CHECKBOX,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input edit-display-wrapper',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'payment' },
      value: savedRestaurantClone.payment,
      name: 'payment',
      type: constants.TYPE.CHECKBOX,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input edit-display-wrapper',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'selectTag' },
      value: savedRestaurantClone.selectTag,
      name: 'selectTag',
      type: constants.TYPE.CHECKBOX,
      isEndOfLine: false,
    }
  ]

  const content = [
    {
      tab: (
        <>
          {tempEditList.map((inputSetting, index) => {
            let content = ''
            switch (inputSetting.type) {
              case constants.TYPE.CHECKBOX:
                content = (
                  <TempCheckBox
                    checkBoxSetting={{
                      className: inputSetting.className,
                      name: inputSetting.name,
                      label: inputSetting.label,
                      value: inputSetting.value,
                    }}
                    handleChange={handleCheckBoxChange}
                  />
                )
                break
              default:
                content = <TempTextInput inputSetting={inputSetting} handleChange={onChangeInput} />
            }
            return (
              <div className="edit-display-wrapper" key={index}>
                {content}
                {inputSetting.isEndOfLine && <div></div>}
              </div>
            )
          })}

          {
            savedRestaurantClone.selectTag && (
              <Box sx={{ pt: '30px', pb: '30px' }}>
                <TempBtn
                  btnSetting=
                  {{
                    onClick: () => setShowSelectTagPanel(true),
                    variant: constants.STYLE.VARIANT.CONTAINED,
                    color: constants.STYLE.PRIMARY,
                    icon: <AddIcon />,
                    label: { resource: resource, key: "addSelectTag" },
                  }}
                ></TempBtn>

                {savedSelectTagConfigOptions && savedSelectTagConfigOptions.length > 0 && savedSelectTagConfigOptions.map((savedSelectTagConfigOptionsValue, savedSelectTagConfigOptionsIndex) => {
                  const tempSelectTagConfigOptionsEditList = [
                    {
                      className: "edit-create-input",
                      variant: constants.STYLE.VARIANT.STANDARD,
                      size: constants.SIZE.SMALL,
                      label: { resource: 'SelectTagConfig', key: "tagCode" },
                      value: savedSelectTagConfigOptionsValue.tagCode,
                      name: "tagCode",
                      isEndOfLine: true,
                      disabled: true,
                    },
                    {
                      className: "edit-create-input",
                      variant: constants.STYLE.VARIANT.STANDARD,
                      size: constants.SIZE.SMALL,
                      label: { resource: 'SelectTagConfig', key: "tagEnName" },
                      value: savedSelectTagConfigOptionsValue.enName,
                      name: "enName",
                      isEndOfLine: false,
                      disabled: true,
                    },
                    {
                      className: "edit-create-input",
                      variant: constants.STYLE.VARIANT.STANDARD,
                      size: constants.SIZE.SMALL,
                      label: { resource: 'SelectTagConfig', key: "tagTcName" },
                      value: savedSelectTagConfigOptionsValue.tcName,
                      name: "tcName",
                      isEndOfLine: false,
                      disabled: true,
                    },
                    {
                      className: "edit-create-input",
                      variant: constants.STYLE.VARIANT.STANDARD,
                      size: constants.SIZE.SMALL,
                      label: { resource: 'SelectTagConfig', key: "tagScName" },
                      value: savedSelectTagConfigOptionsValue.scName,
                      name: "scName",
                      isEndOfLine: true,
                      disabled: true,
                    },
                    {
                      className: "edit-create-input",
                      variant: constants.STYLE.VARIANT.STANDARD,
                      size: constants.SIZE.SMALL,
                      label: { resource: 'SelectTagConfig', key: "status" },
                      value: savedSelectTagConfigOptionsValue.status,
                      name: "status",
                      //type: constants.TYPE.SELECT,
                      selectValue: constants.CHOICES.SELECT_TAG.STATUS,
                      required: true,
                      isEndOfLine: false,
                      disabled: true,
                    },
                    {
                      className: "edit-create-input",
                      size: constants.SIZE.SMALL,
                      label: { resource: 'SelectTagConfig', key: "type" },
                      value: savedSelectTagConfigOptionsValue.type,
                      name: "type",
                      type: constants.TYPE.SELECT,
                      selectValue: constants.CHOICES.SELECT_TAG.TYPE,
                      isEndOfLine: false,
                      required: true,
                      disabled: false,
                      helperTextIcon: true,
                      helperText: SelectTagValidation.getErrorMessages(`${savedSelectTagConfigOptionsIndex}-${selectTagValidationConstants.KEY_TYPE}`),
                      FormHelperTextProps: { className: helperTextStylesClasses.root },
                    },{
                      className: "edit-create-input",
                      size: constants.SIZE.SMALL,
                      label: { resource: 'SelectTagConfig', key: "sequence" },
                      value: savedSelectTagConfigOptionsValue.sequence,
                      name: "sequence",
                      //eslint-disable-next-line
                      pattern: "^\d*$",
                      isEndOfLine: true,
                      required: true,
                      helperTextIcon: true,
                      helperText: SelectTagValidation.getErrorMessages(`${savedSelectTagConfigOptionsIndex}-${selectTagValidationConstants.KEY_DISPLAY_SEQUENCE}`),
                      FormHelperTextProps: { className: helperTextStylesClasses.root },
                    },
                  ]
                  return <Card key={savedSelectTagConfigOptionsIndex} className="image-list"> {
                    <>
                      <div className="delete-icon">
                        <TempBtn btnSetting={{
                          className: "edit-create-btn",
                          variant: constants.STYLE.VARIANT.CONTAINED,
                          color: constants.STYLE.PRIMARY,
                          onClick: () => {
                            let tempSelectTagConfigOptionsList = _.cloneDeep(savedSelectTagConfigOptions);
                            tempSelectTagConfigOptionsList = tempSelectTagConfigOptionsList.filter((item, index) => { return index !== savedSelectTagConfigOptionsIndex });
                            dispatch(setSelectTagConfigOptions(tempSelectTagConfigOptionsList));
                            setSelectTagMap(new Map(tempSelectTagConfigOptionsList.map(item => [item.tagCode, item])));
                            SelectTagValidation.resetErrorMessages();
                          },
                          label: { key: "deleteBtn" },
                          icon: <DeleteIcon />,
                        }} />
                      </div>
                      {tempSelectTagConfigOptionsEditList.map((inputSetting, index) => {
                        let content = <></>;
                        switch (inputSetting.type) {
                          case constants.TYPE.SELECT:
                            content =
                              <TempAutoSelectInput inputSetting={inputSetting} handleChange={onChangeInput} index={savedSelectTagConfigOptionsIndex}/>
                            break;
                          default:
                            content =
                              <TempTextInput inputSetting={inputSetting} handleChange={onChangeInput} index={savedSelectTagConfigOptionsIndex}/>
                        }
                        return <div className={inputSetting.backgroundColorClass ? "image-card-background card-border" : "edit-display-wrapper"} key={index}>
                          {content}
                          {inputSetting.isEndOfLine && <div></div>}
                        </div>
                      })
                      }
                    </>
                  }
                  </Card>
                })}
                <Drawer
                  classes={{ paper: "drawer-margin-left" }}
                  anchor="right"
                  open={showSelectTagPanel}
                  onClose={() => setShowSelectTagPanel(false)}
                >
                  <SelectTagList
                    editBtn={false}
                    mutipleSelect={true}
                    createBtn={false}
                    btnList={false}
                    selectMap={selectTagMap}
                    setSelectMap={setSelectTagMap}
                    newFilter={selectTagMap && selectTagMap.size > 0 ?{ selected: { column: 'tagCode', valueList:  Array.from(selectTagMap, ([name, value]) => (name)) } }: null}
                    restUrlId={params.restUrlId}
                    dialogFooterBtn={
                      <div className="get-push-card-wrapper">
                        <TempBtn btnSetting={{
                          className: "edit-create-btn",
                          variant: constants.STYLE.VARIANT.CONTAINED,
                          color: constants.STYLE.PRIMARY,
                          onClick: () => {
                            // dispatch(setRestaurantCloneValue('selectTagMap', savedRestaurantClone, '', selectTagMap))
                            dispatch(setSelectTagConfigOptions([...Array.from(selectTagMap, ([name, value]) => ({...value, status: 'A', restUrlId: params.restUrlId}))]))
                            setShowSelectTagPanel(false)
                          },
                          label: { key: "submit" },
                          icon: <AddIcon />
                        }} />
                        <TempBtn btnSetting={{
                          className: "edit-create-btn",
                          variant: constants.STYLE.VARIANT.CONTAINED,
                          color: constants.STYLE.PRIMARY,
                          onClick: () => setShowSelectTagPanel(false),
                          label: { key: "close" },
                          icon: <ClearIcon />
                        }} />
                      </div>
                    }
                  />
                </Drawer>
              </Box>
            )
          }
          
          <Box sx={{ pt: '30px', pb: '30px' }}>
            <TempCheckBox
              checkBoxSetting={{
                className: 'edit-create-input edit-display-wrapper',
                name: 'merchantUserCreate',
                label: { resource: resource, key: 'merchantUserCreate' },
                value: savedRestaurantClone.merchantUserCreate,
              }}
              handleChange={handleCheckBoxChange}
            />
            {savedRestaurantClone.merchantUserCreate && (
              <MerchantUserCreate hideTab={true} hideBottomBtnList={true} hidePrivilegeRestUrlIdEditButton={true} embeddedInRestaurantClone={true} />
            )}
          </Box>
        </>
      ),
      btn: true,
    },
  ]
  const bottomBtns = [
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: 'save' },
      disabled:
        !savedRestaurantClone.restUrlIdSource ||
        !savedRestaurantClone.restUrlIdTarget ||
        (savedRestaurantClone.merchantUserCreate &&
          (!savedMerchantUser.privilegeRestUrlId || !savedMerchantUser.username || !savedMerchantUser.password)),
      onClick: onClickSave,
      className: 'margin-left-16',
      icon: <SaveIcon />,
    },
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: 'clear' },
      disabled: false,
      onClick: onClickClear,
      className: 'margin-left-16',
      icon: <ClearIcon />,
    },
  ]

  const handleBackClone = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    onClickClear()
  }
  const onClickBackToList = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    history.push('/' + constants.PATH.SHOP.SYSTEM_GROUP_RESTAURANT)
  }

  function onChangeInput(name, e) {
    dispatch(setRestaurantCloneValue(name, savedRestaurantClone, '', e))
    if (name === 'restUrlIdTarget') {
      let tempMerchantUser = _.cloneDeep(savedMerchantUser)
      tempMerchantUser.privilegeRestUrlId = e
      tempMerchantUser.username = 'shop' + e
      dispatch(setMerchantUser(tempMerchantUser))
    }
  }
  function handleCheckBoxChange(name, e) {
    dispatch(setRestaurantCloneValue(name, savedRestaurantClone, '', e ? false : true)) // e False When Switch On The Checkbox

    if (name === 'merchantUserCreate' && !e && savedRestaurantClone.restUrlIdTarget) {
      let tempMerchantUser = _.cloneDeep(savedMerchantUser)
      tempMerchantUser.privilegeRestUrlId = savedRestaurantClone.restUrlIdTarget
      tempMerchantUser.username = 'shop' + savedRestaurantClone.restUrlIdTarget
      dispatch(setMerchantUser(tempMerchantUser))
    }
  }

  async function onClickSave() {
    if (!restUrlIdRegex.test(savedRestaurantClone.restUrlIdTarget)) {
      setRestUrlIdError('restUrlId includes invalid characters or Too long . Valid Character: numbers. Possible length: <=20')
      return
    } else {
      setRestUrlIdError('')
    }

    const tempRestaurantClone = _.cloneDeep(savedRestaurantClone)
    let body = tempRestaurantClone

    //----------------------Merchant User Create------------------------

    if (savedRestaurantClone.merchantUserCreate) {
      MerchantUserValidation.validateCreateMerchantUser(savedMerchantUser)

      if (MerchantUserValidation.isValid()) {
        body = {
          ...tempRestaurantClone,
          merchantUser: {
            username: savedMerchantUser.username,
            email: savedMerchantUser.email,
            password: savedMerchantUser.password,
            userRole: savedMerchantUser.userRole,
            privilegeAttribute: savedMerchantUser.privilegeAttribute,
            privilegeRestUrlId: savedMerchantUser.privilegeRestUrlId,
            privilegeGroupCode: savedMerchantUser.privilegeGroupCode,
            merchantRole: savedMerchantUser.merchantRole,
            merchantUserList: savedMerchantUser.merchantUserList,
          },
        }
        MerchantUserValidation.resetErrorMessages()
      } else {
        setErrorVersion(MerchantUserValidation.getVersion())
        return
      }
    }

    //----------------------End Of Merchant User Create------------------------

    post(
      constants.PATH.SHOP.RESTAURANT_CLONE,
      body,
      () => {
        setDialog({
          open: true,
          onClose: handleBackClone,
          dialogContentText: { key: 'createSuccess' },
          dialogActions: [
            { label: { key: 'backCreate' }, onClick: handleBackClone, icon: <ArrowBackIcon /> },
            { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
          ],
        })
        setClear(false)
      },
      undefined,
      store
    )
  }

  function onClickClear() {
    setRestUrlIdError('')
    setClear(true)
  }

  useEffect(() => {
    let tempRestaurantClone = _.cloneDeep(constants.RESTAURANT_CLONE_INPUT)
    tempRestaurantClone.restUrlIdSource = params.id
    dispatch(setRestaurantClone(tempRestaurantClone))
    setClear(false)
    setRestUrlIdError('')

    dispatch(setMerchantUser(constants.MERCHANT_USER_INPUT))
    MerchantUserValidation.resetErrorMessages()
  }, [clear === true]) // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect(() => {
  //   console.log('savedRestaurantClone', savedRestaurantClone)
  // }, [savedRestaurantClone])

  // useEffect(() => {
  //   console.log('savedMerchantUser', savedMerchantUser)
  // }, [savedMerchantUser])

  return (
    <>
      <EditCreateDisplay
        code=""
        resource={resource}
        tabs={tabs}
        content={content}
        onChangeInput={onChangeInput}
        bottomBtns={bottomBtns}
        display="clone"
      />
      {dialog && dialog.open && <GlobalDialog dialogInfo={dialog} />}
    </>
  )
}
